<!--  If editing a saved draft this is a modal, otherwise it's a tab in the window  -->
@if (!!request) {
  <div class="modal-header">
    <div class="modal-title h4" tabindex="-1" ngbAutofocus>
      Update Request
    </div>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div>
}

<div [class.modal-body]="!!request">
  @if (tcSubmit$ | async) {
  }
  @if (course$ | async; as course) {
    @if (course.isNew || course.isChanged) {
      <div class="alert alert-warning mt-2">
        @if (course?.ApprovalStatus == 'Approved') {
          The current pre-approved course has changed. If submitted, this course will need to be approved.
        }
        @if (course?.ApprovalStatus != 'Approved') {
          This is a new request for a course that has not been previously approved and will require review.
        }
      </div>
    }
    <form>
      <!--  Institution and Country  -->
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group form-control-sm">
            <label for="Institution">Institution</label>
            <select id="Institution"
              name="Institution"
              class="form-select form-select-sm"
              [(ngModel)]="course.HostProgram"
              (ngModelChange)="course.onChange()"
              [attr.required]="true"
              [disabled]="!course.isNew">
              <option value="">-- Select an institution --</option>
              @for (uni of transferCredits.institutions$ | async; track uni) {
                <option [value]="uni">{{ uni }}</option>
              }
            </select>
          </div>
        </div>
        <div class="col-12 col-md-6">
          @if (!!course.HostProgram) {
            <div class="form-group form-control-sm">
              <label for="HostCountry">Country</label>
              <input type="text"
                id="HostCountry"
                name="HostCountry"
                class="form-control form-control-sm"
                [(ngModel)]="course.HostCountry"
                (ngModelChange)="course.onChange()"
                disabled />
              </div>
            }
          </div>
        </div>
        <!-- AoE  -->
        <div class="row">
          <div class="col-12 col-lg-6">
            <ng-container [ngTemplateOutlet]="tcTextField"
                                  [ngTemplateOutletContext]="{
                                  course: course,
                                  title: 'Host Course Name',
                                  name: 'HostCourseName',
                                  canEdit: true,
                                  required: true,
                                  maxLength: 200,
                                  autoComplete: 'off'}">
            </ng-container>
          </div>
          @if (!!showAoE) {
            <div class="col-12 col-md-4 col-lg-2">
              <div class="form-group form-control-sm mb-2">
                <fieldset>
                  <legend class="form-label">Seeking Area of Emphasis Credit?</legend>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input"
                      type="radio"
                      name="showAreasOfEmphasis"
                      id="showAreasYes"
                      [value]="true"
                      [(ngModel)]="course.hasAoE"
                      (ngModelChange)="course.onChange()">
                      <label class="form-check-label" for="showAreasYes">Yes</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input"
                        type="radio"
                        name="showAreasOfEmphasis"
                        id="showAreasNo"
                        [value]="false"
                        [(ngModel)]="course.hasAoE"
                        (ngModelChange)="course.onChange()">
                        <label class="form-check-label" for="showAreasNo">No</label>
                      </div>
                    </fieldset>
                  </div>
                </div>
                @if (transferCredits.lookups$ | async; as lookups) {
                  <div class="col">
                    @if (course.hasAoE) {
                      <div class="form-group form-control-sm">
                        <label for="areaOfEmphasis">Area Of Emphasis</label>
                        <select id="areaOfEmphasis"
                          name="areaOfEmphasis"
                          class="form-select form-select-sm"
                          [(ngModel)]="course.AreaOfEmphasis"
                          (ngModelChange)="course.onChange()">
                          <option value="">-- Select Area --</option>
                          <!--  No AoE Groupings  -->
                          @if (!course.activeAreas?.length && !lookups.discontinuedAreas?.length) {
                            @for (emphasis of lookups.emphasisOptionsList; track emphasis) {
                              <option [value]="emphasis.Value">
                                {{emphasis.Key}}
                              </option>
                            }
                          }
                          <!--  Has Pre-Approved or Discontinued AoEs  -->
                          @if (course.activeAreas?.length || lookups.discontinuedAreas?.length) {
                            @if (course.AreasOfEmphasis?.length && !course.isNew) {
                              <optgroup label="Pre-Approved">
                                @for (emphasis of lookups.activeAreas; track emphasis) {
                                  @if (course.AreasOfEmphasis?.includes(emphasis)) {
                                    <option [value]="emphasis">
                                      {{emphasis}}
                                    </option>
                                  }
                                }
                              </optgroup>
                            }
                            <optgroup label="Not Pre-Approved, Available to Request">
                              @for (emphasis of lookups.activeAreas; track emphasis) {
                                @if (!course.AreasOfEmphasis?.includes(emphasis) || course.isNew) {
                                  <option [value]="emphasis">
                                    {{emphasis}}
                                  </option>
                                }
                              }
                            </optgroup>
                            @if (lookups.discontinuedAreas?.length) {
                              <optgroup label="Discontinued">
                                @for (emphasis of lookups.discontinuedAreas; track emphasis) {
                                  <option [value]="emphasis">
                                    {{emphasis}}
                                  </option>
                                }
                              </optgroup>
                            }
                          }
                        </select>
                        @if (!!course.warnings['AreaOfEmphasis']) {
                          <div class="alert alert-warning mt-1">{{course.warnings['AreaOfEmphasis']}}</div>
                        }
                        @if (course.hasAoE && ((course.AreaOfEmphasis && !course.AreasOfEmphasis?.includes(course.AreaOfEmphasis)) || course.isNew)) {
                          <div class="mt-2">
                            <div class="d-flex justify-content-end">
                              <label class="sr-only" for="AoeJustification">Area Of Emphasis Justification</label>
                              <div class="small">{{course.AoeJustification?.length ?? 0}}/1000</div>
                            </div>
                            <textarea id="AoeJustification"
                              name="AoeJustification"
                              class="form-control form-control-sm"
                              rows="3"
                              [(ngModel)]="course.AoeJustification"
                              (ngModelChange)="course.onChange()"
                              required
                              maxlength="1000"
                            placeholder="Enter justification"></textarea>
                            <div class="alert alert-primary">Enter justification for as to why you think this course aligns with your AOE. Use specifics from the syllabus to bolster your case. This justification is sent to our faculty for review.</div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              }
            </div>
            <!--  Host Credit Hours and Course Number  -->
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group form-control-sm">
                  <label for="HostCourseCreditHours">Host Course Credit Hours</label>
                  <button class="btn btn-explain text-primary small" (click)="explainHostCourseHours = !explainHostCourseHours">({{ !explainHostCourseHours ? 'explain' : 'hide'}})</button>
                  @if (!!explainHostCourseHours) {
                    <div class="alert alert-info mb-1">
                      The number of credit hours for the course listed on the syllabus at your host institution.
                      You can view our ‘Academics Procedures’ webpage for details on the credit conversion from host credit hours to UNC credit hours under the
                      ‘<a href="https://www.kenan-flagler.unc.edu/programs/undergraduate-business/global-programs/academic-procedures/" target="_blank">Credit Hour Conversions</a>’ tab,
                      but use this space to list the credit hours the way your host university reports them!
                    </div>
                  }
                  <input type="number"
                    id="HostCourseCreditHours"
                    name="HostCourseCreditHours"
                    class="form-control form-control-sm"
                    [(ngModel)]="course.HostCourseCreditHours"
                    (ngModelChange)="course.onChange()"
                    [attr.min]="1"
                    autocomplete="{{ !!autoComplete ? autoComplete : 'on'}}"
                    #field="ngModel"
                    required />
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <div class="form-group form-control-sm">
                    <label for="HostCourseNumber">Host Course Number</label>
                    <button class="btn btn-explain text-primary small" (click)="explainHostCourseNumber = !explainHostCourseNumber">({{ !explainHostCourseNumber ? 'explain' : 'hide'}})</button>
                    @if (!!explainHostCourseNumber) {
                      <div class="alert alert-info mb-1">The course number listed on the syllabus/in the course catalog at
                        your host institution. Some institutions have different course numbers for the same course (they may change the course number based
                      on the semester the course is offered, so be sure to select the right one).</div>
                    }
                    <select id="HostCourseNumber"
                      name="HostCourseNumber"
                      class="form-select form-select-sm"
                      [(ngModel)]="course.HostCourseNumber"
                      (ngModelChange)="course.onChange()"
                      required>
                      <option value="" selected>-- Select approved course number --</option>
                      @for (num of course.HostCourseNumbers; track num) {
                        <option [value]="num">{{num}}</option>
                      }
                      <option value="Other">Other - Requires Approval</option>
                    </select>
                    @if (course.HostCourseNumber == 'Other') {
                      <div class="mt-2">
                        <div class="d-flex justify-content-end">
                          <label class="sr-only" for="otherHostCourseNumber">Other Host Course number</label>
                          <div class="small">{{course.otherHostCourseNumber?.length ?? 0}}/25</div>
                        </div>
                        <input type="text"
                          id="otherHostCourseNumber"
                          name="otherHostCourseNumber"
                          class="form-control form-control-sm"
                          [(ngModel)]="course.otherHostCourseNumber"
                          (ngModelChange)="course.onChange()"
                          required
                          maxlength="25"
                          placeholder="Enter course number" />
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <hr />
                <!--  UNC Primary Course Name and Department  -->
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="form-group form-control-sm">
                      <label for="courseSelect">UNC Course Name</label>
                      <button class="btn btn-explain text-primary small" (click)="explainUncPrimary = !explainUncPrimary">({{ !explainUncPrimary ? 'explain' : 'hide'}})</button>
                      @if (!!explainUncPrimary) {
                        <div class="alert alert-info mb-1">
                          Select from this list the UNC Course you are seeking credit for. You’ll then input all other relevant information pertaining to the UNC course.
                        </div>
                      }
                      <select class="form-select form-select-sm" id="courseSelect" name="Course"
                        [(ngModel)]="course.UncPrimaryCourseName"
                        (ngModelChange)="onUncCourseSelect($event, course)">
                        <option value="">-- Select UNC Course Name --</option>
                        @for (uncCourse of uncCourses; track uncCourse) {
                          <option [ngValue]="uncCourse">{{uncCourse.display}}</option>
                        }
                      </select>
                      @if ((course.UncPrimaryCourseName?.display == 'Other') || (course.UncPrimaryCourseName == 'Other')
                        || (course.UncPrimaryCourseName?.display == 'UNC Equivalent Business Elective Credit') || (course.UncPrimaryCourseName == 'UNC Equivalent Business Elective Credit')) {
                        <div
                          class="mt-2">
                          <div class="d-flex justify-content-end">
                            <label class="sr-only" for="otherPrimaryCourseName">Other UNC Course Name</label>
                            <div class="small">{{course.otherPrimaryCourseName?.length ?? 0}}/150</div>
                          </div>
                          <input type="text"
                            id="otherPrimaryCourseName"
                            name="otherPrimaryCourseName"
                            class="form-control form-control-sm"
                            [(ngModel)]="course.otherPrimaryCourseName"
                            (ngModelChange)="course.onChange()"
                            required
                            maxlength="150"
                            placeholder="Enter course name" />
                          </div>
                        }
                      </div>
                    </div>
                    @if (course.UncPrimaryCourseName?.display == 'General Education Requirement' || course.UncPrimaryCourseName == 'General Education Requirement') {
                      <div class="col-12 col-lg-6">
                        @if (transferCredits.lookups$ | async; as lookups) {
                          <div class="form-group form-control-sm">
                            <label for="GenEdSelect">General Education Requirement</label>
                            <select class="form-select form-select-sm" id="GenEdSelect" name="GenEd"
                              [(ngModel)]="course.GeRequirement"
                              (ngModelChange)="onGenEdSelect($event, course)">
                              @for (genEd of lookups.ubpGenEdList; track genEd) {
                                <option [ngValue]="genEd">
                                  {{genEd.Key}}
                                </option>
                              }
                            </select>
                          </div>
                        }
                      </div>
                    }
                    <div class="col-12 col-lg-6">
                      @if (transferCredits.lookups$ | async; as lookups) {
                        <div class="form-group form-control-sm">
                          <label for="deptSelect">UNC Department</label>
                          <select class="form-select form-select-sm" id="deptSelect" name="Dept"
                            [(ngModel)]="course.UncDepartment" (ngModelChange)="course.onChange()"
                            [disabled]="course.UncPrimaryCourseName?.display != 'Other' && course.UncPrimaryCourseName != 'Other'">
                            <option value=""></option>
                            @for (dept of lookups.departmentsOptionsList; track dept) {
                              <option [value]="dept.Key">
                                {{dept.Value}}
                              </option>
                            }
                          </select>
                        </div>
                      }
                    </div>
                    <!--  UNC Primary Course Number and UNC Primary Credit Hours-->
                    @if (!!course.UncPrimaryCourseName) {
                      <div class="col-12 col-md-6">
                        <ng-container [ngTemplateOutlet]="tcTextField"
                                  [ngTemplateOutletContext]="{
                                  course: course,
                                  title: 'UNC Course Number',
                                  name: 'UncPrimaryCourseNumber',
                                  canEdit: !course.UncPrimaryCourseName?.number && (course.UncPrimaryCourseName?.display != 'General Education Requirement'),
                                  maxLength: 15 }">
                        </ng-container>
                      </div>
                    }
                    <div class="col-12 col-md-6">
                      <ng-container [ngTemplateOutlet]="tcTextField"
                                  [ngTemplateOutletContext]="{
                                course: course,
                                title: 'UNC Credit Hours',
                                name: 'UncPrimaryCreditHours',
                                canEdit: true,
                                type: 'number' }">
                      </ng-container>
                    </div>
                  </div>
                  <!--  Optional UNC Secondary Course Name, Number, and Credit Hours-->
                  @if (!!course.UncSecondaryCourseName && !course.isNew) {
                    <div class="row">
                      <div class="col-12 col-lg-6">
                        <div class="form-group form-control-sm">
                          <label for="UncSecondaryCourseName">Secondary UNC Course Name</label>
                          <button class="btn btn-explain text-primary small" (click)="explainUncSecondary = !explainUncSecondary">({{ !explainUncSecondary ? 'explain' : 'hide'}})</button>
                          @if (!!explainUncSecondary) {
                            <div class="alert alert-info mb-1">
                              When you see a Secondary UNC Course Name appear, it usually is because the course at a host university is worth more than 3 UNC credit hours. As the maximum
                              amount of business credit any one course can receive is 3 UNC credit hours, if a singular course is worth more than the equivalent of 3 UNC credit hours, the
                              additional hours will transfer back as general elective hours. We transfer these hours as the ‘Secondary UNC Course Name’. You may also see this appear when a
                              course is approved for a specific 1. 5 credit hour UNC course (like BUSI 411, for example), but is worth more than 1.5 UNC credit hours.
                            </div>
                          }
                          <input type="text"
                            id="UncSecondaryCourseName"
                            name="UncSecondaryCourseName"
                            class="form-control form-control-sm"
                            [(ngModel)]="course.UncSecondaryCourseName"
                            disabled />
                          </div>
                        </div>
                        @if (!!course.UncPrimaryCourseName) {
                          <div class="col-12 col-lg-6">
                            <ng-container [ngTemplateOutlet]="tcTextField"
                                  [ngTemplateOutletContext]="{
                                  course: course,
                                  title: 'Secondary UNC Course Number',
                                  name: 'UncSecondaryCourseNumber',
                                  canEdit: false }">
                            </ng-container>
                          </div>
                        }
                        <div class="col-12 col-md-6">
                          <ng-container [ngTemplateOutlet]="tcTextField"
                                  [ngTemplateOutletContext]="{
                                  course: course,
                                  title: 'Secondary UNC Credit Hours',
                                  name: 'UncSecondaryCreditHours',
                                  canEdit: false,
                                  type: 'number' }">
                          </ng-container>
                        </div>
                      </div>
                    }
                    <!--  Student Notes  -->
                    @if (!!course.StudentNotes) {
                      <div class="form-control-sm">
                        <div class="label">Notes</div>
                        <div id="studentNotes" name="studentNotes" class="form-control-sm disabled-text">
                          {{ course.StudentNotes }}
                        </div>
                      </div>
                    }
                    <!-- Term  -->
                    @if (transferCredits.lookups$ | async; as lookups) {
                      <div class="form-group form-control-sm">
                        <label for="termSelect">Term Abroad</label>
                        <button class="btn btn-explain text-primary small" (click)="explainTerm = !explainTerm">({{ !explainTerm ? 'explain' : 'hide'}})</button>
                        @if (!!explainTerm) {
                          <div class="alert alert-info mb-1">
                            Select the UNC term you are studying abroad in/plan to study abroad in. NOTE: If you have not been accepted & enrolled in a program, you
                            can indicate the term you plan to study abroad in, but save your request as a DRAFT and DO NOT submit your request.
                          </div>
                        }
                        <select class="form-select form-select-sm" id="termSelect" name="Term"
                          [(ngModel)]="course.Term" (ngModelChange)="course.onChange()">
                          @for (term of lookups.termsOptionsList; track term) {
                            <option [value]="term.Key">
                              {{term.Value}}
                            </option>
                          }
                        </select>
                      </div>
                    }
                    <!-- Syllabus  -->
                    @if (course.isNew || course.isChanged) {
                      <div class="form-group form-control-sm mb-2">
                        <label class="mb-0 col-form-label-sm me-2" for="syllabusUpload">Syllabus</label>
                        @if (!!course?.SyllabusFilename) {
                          <button class="btn btn-link btn-sm ms-1 mb-1" (click)="transferCredits.openSyllabus(course.RequestId, course.SyllabusFilename)">{{course.SyllabusFilename}}</button>
                        }
                        <input type="file" class="form-control-file form-control-sm"
                          id="syllabusUpload" name="syllabusUpload"
                          [(ngModel)]="course.filename" #syllabusInput
                          (change)="syllabusChanged(course)"
                          required
                          accept="{{acceptedFileTypes.toString()}}">
                        </div>
                      }
                      <!--  Errors  -->
                      @if (!!course.hasErrors) {
                        <div class="alert alert-danger pb-0">
                          <i class="fas fa-exclamation-triangle text-danger me-2"></i><strong>Correct the following to submit your request:</strong>
                          <ul>
                            @for (error of course.errors | keyvalue: preserveOrder; track error) {
                              <li [innerHTML]="error.value"></li>
                            }
                          </ul>
                        </div>
                      }
                      <!-- Submit/Save  -->
                      <div class="form-group form-control-sm">
                        <button class="btn btn-primary"
                          [disabled]="!!course.hasErrors || course.isSaving"
                          (click)="onSave(course, true)">
                          Submit
                        </button>
                        @if (request?.Status != 'More Info') {
                          <span
                            [title]="!course.Term ? 'Term Abroad is required to save a draft' : ''">
                            <button class="btn btn-success ms-2"
                              [disabled]="!course.Term || course.isSaving || !course.isDirty"
                              (click)="onSave(course)">
                              Save Draft
                              @if (!course.Term) {
                                <span class="sr-only">Term is required to save a draft.</span>
                              }
                            </button>
                          </span>
                        }
                        @if (course.isSaving) {
                          <span class="ms-2"><i class="fas fa-circle-notch fa-spin"></i> Please wait...</span>
                        }
                      </div>
                    </form>
                  } @else {
                    <div class="widget-loading text-center">
                      <i class="fas fa-circle-notch fa-spin"></i>
                    </div>
                  }
                </div>


                <ng-template #tcTextField let-course="course" let-title="title" let-name="name" let-canEdit="canEdit" let-type="type"
                  let-required="required" let-maxLength="maxLength" let-autoComplete="autoComplete">
                  <div class="form-group form-control-sm">
                    <div class="d-flex justify-content-between">
                      <label for="{{ name }}">{{ title }}</label>
                      @if (canEdit && !!maxLength) {
                        <div class="small">{{course[name]?.length ?? 0}}/{{maxLength}}</div>
                      }
                    </div>
                    <input [type]="type || 'text'" id="{{ name }}" name="{{ name }}"
                      class="form-control form-control-sm"
                      [(ngModel)]="course[name]"
                      (ngModelChange)="course.onChange()"
                      [attr.required]="required ? '' : null"
                      [attr.min]="type === 'number' ? 1 : null"
                      [maxlength]="maxLength"
                      [disabled]="!canEdit"
                      autocomplete="{{ !!autoComplete ? autoComplete : 'on'}}"
                      #field="ngModel" />
                    </div>
                  </ng-template>
